import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDataLayer from 'src/hooks/useDataLayer';
import { setColour, refreshBikeAccessories, updatePackAccessories } from 'src/redux/bike/actions';
import { bikeModelSelector, bikeColoursSelector } from 'src/redux/bike/selectors';
import request from 'helpers/request';
import { setAccessoryItems, setAccessoryCategories } from 'src/redux/configurator/actions';
import { setError } from 'src/redux/app/actions';

const useChooseColour = () => {
  const dispatch = useDispatch();
  const pushToDataLayer = useDataLayer();
  const bikeModel = useSelector(bikeModelSelector);
  const bikeColours = useSelector(bikeColoursSelector);

  const chooseColour = async colourId => {
    const selectedColour = bikeColours.find(colour => colour.id === colourId);

    dispatch(setColour(colourId));

    pushToDataLayer('configuratorColourSelected', {
      configuratorBikeColour: selectedColour.name,
      configuratorColourPrice: selectedColour.price - bikeModel.price,
    });

    try {
      const {
        data: { categories, accessories },
      } = await request(`/api/configurator/accessories/${bikeModel.id}?colour=${colourId}`);
      dispatch(setAccessoryCategories(categories));
      dispatch(setAccessoryItems(accessories));
      dispatch(refreshBikeAccessories(accessories));
      dispatch(updatePackAccessories(accessories));
    } catch (ex) {
      dispatch(setError(ex));
    }
  };

  return chooseColour;
};

export default useChooseColour;
